import { Rule } from "antd/es/form";
import { Dayjs } from "dayjs";
import { useMemo } from "react";
import { DATE_FORMAT } from "../../../lib/constants";
import dayjs from "../../../configs/dayjs";

export const usePayoffDateRule = () => {
  const rule: Rule[] = useMemo(() => {
    return [
      () => ({
        validateTrigger: "onSubmit",
        validator(_: Rule, value: Dayjs) {
          if (!value) {
            return Promise.reject("Intended Payoff Date is required");
          }

          const current = value.startOf("D");
          const minDate = dayjs().startOf("D");

          if (minDate.diff(current) > 0) {
            return Promise.reject(
              new Error(
                `Date must be greater than ${minDate.format(DATE_FORMAT)}`,
              ),
            );
          }

          return Promise.resolve("");
        },
      }),
    ];
  }, []);

  return { rule };
};
